export default [
  {
    path: '/main/permission',
    meta: {
      tag: 'list_permission',
      name: 'Permissões',
      breadcrumb: 'Permissões'
    },
    component: () => import(/* webpackChunkName: "permission-list" */ '@/views/main/settings/users/permission/Index.vue'),
    children: [
      {
        path: '',
        name: 'listpermission',
        meta: {
          tag: 'list_permission',
          menu: 'settings',
          name: 'Permissões'
        },
        component: () => import(/* webpackChunkName: "permission-list" */ '@/views/main/settings/users/permission/List.vue')
      },
      {
        path: '/main/permission/add',
        name: 'addpermission',
        meta: {
          tag: 'add_permission',
          menu: 'settings',
          name: 'Adicionar | Permissão',
          breadcrumb: 'Adicionar Permissão'
        },
        component: () => import(/* webpackChunkName: "permission-add" */ '@/views/main/settings/users/permission/Add.vue')
      },
      {
        path: '/main/permission/:id',
        name: 'editpermission',
        meta: {
          tag: 'edit_permission',
          menu: 'settings',
          name: 'Editar | Permissão',
          breadcrumb: 'Editar Permissão'
        },
        component: () => import(/* webpackChunkName: "permission-edit" */ '@/views/main/settings/users/permission/Edit.vue')
      }
    ]
  }
]